import { render } from "./TeamSelect.vue?vue&type=template&id=4fc4404b&scoped=true"
import script from "./TeamSelect.vue?vue&type=script&lang=js"
export * from "./TeamSelect.vue?vue&type=script&lang=js"

import "./TeamSelect.vue?vue&type=style&index=0&id=4fc4404b&lang=scss&scoped=true"

import exportComponent from "/Users/simonkravec/weby/zmen-form/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fc4404b"]])

export default __exports__